<form (ngSubmit)="save()" [formGroup]="form">
    <div class="flex items-center" mat-dialog-title>
        <h2 *ngIf="form.get('name').value"
            class="headline m-0 flex-auto">{{ form.get('name').value }}</h2>
        <h2 *ngIf="!form.get('name').value"
            class="headline m-0 flex-auto">Nueva Moneda</h2>
    </div>

    <mat-divider class="-mx-6 text-border"></mat-divider>

    <mat-dialog-content class="flex flex-col">
        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="flex-auto">
                <mat-label>Nombre</mat-label>
                <input cdkFocusInitial formControlName="name" matInput required>
                <mat-icon class="mr-3" matPrefix svgIcon="mat:attach_money"></mat-icon>
                <mat-error *ngIf="form.get('name')?.hasError('required')">
                    El nombre es requerido
                </mat-error>
            </mat-form-field>
        </div>
        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="flex-auto">
                <mat-label>Código</mat-label>
                <input formControlName="code" matInput required maxlength="3" style="text-transform: uppercase;">
                <mat-icon class="mr-3" matPrefix svgIcon="mat:code"></mat-icon>
                <mat-hint>Ej: USD, EUR, CLP</mat-hint>
                <mat-error *ngIf="form.get('code')?.hasError('required')">
                    El código es requerido
                </mat-error>
            </mat-form-field>
        </div>
        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="flex-auto">
                <mat-label>Símbolo</mat-label>
                <input formControlName="symbol" matInput>
                <mat-icon class="mr-3" matPrefix svgIcon="mat:currency_exchange"></mat-icon>
                <mat-hint>Ej: $, €, £</mat-hint>
            </mat-form-field>
        </div>
        <div class="flex flex-col sm:flex-row">
            <mat-slide-toggle formControlName="active" color="primary">
                Activo
            </mat-slide-toggle>
        </div>
    </mat-dialog-content>

    <mat-divider class="-mx-6 text-border"></mat-divider>

    <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="cancel()">Cancelar</button>
        <button mat-button color="primary" type="submit" [disabled]="!form.valid">
            {{ mode === 'create' ? 'Crear' : 'Actualizar' }}
        </button>
    </mat-dialog-actions>
</form>

